module.exports = "<div class=\"list profiles\"> <div class=\"item profile\" ng-repeat=\"collector in $ctrl.list\" ng-click=\"!collector.associationConflict && $ctrl.select({collector: collector})\"> <ink-profile-photo type=$ctrl.type profile=collector linkable=\"collector.associationConflict === false\" invited=collector.associationConflict image-id=collector.profile_photo> </ink-profile-photo> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/collector/collector-list/collector-list.template.html
// module id = ./components/collector/collector-list/collector-list.template.html
// module chunks = 0